import { PlatformConstants } from "@quest/platform-murka-phase_2/dist/PlatformConstants"


export class PlatformConstantsGame extends PlatformConstants {
    // code here
}
PlatformConstants.BASE_GAME_REELSET = 'paidSpin_100';
PlatformConstants.FREE_GAME_REELSET = 'freeSpin_100';


